import { on } from '../helpers';
import View from './change_email_view';

const initPage = () => {
    const view = new View();
}

on(window, 'load', initPage);
